import {Button} from '@primer/react'

import styles from '../SimpleSelect.module.css'
import type {FooterButtons} from '../types'

// action is not valid on a `button` element, so we omit it here to make sure we avoid passing it through
type FooterButtonsWithoutAction = Omit<FooterButtons, 'action'> & {action?: never}

type SelectFooterBtns = {
  save?: FooterButtonsWithoutAction
  cancel?: FooterButtonsWithoutAction
  supplementary: FooterButtonsWithoutAction[]
}

export function SelectFooter({
  footerButtons,
  onSave,
  onCancel,
}: {
  footerButtons?: FooterButtons[]
  onSave?: () => void
  onCancel?: () => void
}) {
  const buttons = footerButtons?.reduce<SelectFooterBtns>(
    (acc, {action, ...button}) => {
      if (action === 'save' || action === 'cancel') {
        acc[action] = button
      } else {
        acc.supplementary.push(button)
      }
      return acc
    },
    {save: undefined, cancel: undefined, supplementary: []},
  )

  return (
    <div className={styles.Footer}>
      <div className={styles.FooterContent}>
        {footerButtons
          ? buttons?.supplementary.map(({variant, content, ...rest}) => (
              <Button key={content} variant={variant || 'default'} {...rest}>
                {content}
              </Button>
            ))
          : null}
      </div>
      <div className={styles.FooterActions}>
        <Button onClick={onCancel} {...buttons?.cancel}>
          {buttons?.cancel?.content || 'Cancel'}
        </Button>
        <Button variant="primary" onClick={onSave} {...buttons?.save}>
          {buttons?.save?.content || 'Save'}
        </Button>
      </div>
    </div>
  )
}

try{ SelectFooter.displayName ||= 'SelectFooter' } catch {}